module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-7.svg?b29151f276ce902121acf670edfef975";